export function initUsersList(root: HTMLElement): void {
    const sendInvitationsUrl = root.dataset.sendInvitationsUrl ?? '';

    if (!sendInvitationsUrl) {
        return;
    }

    $(document).on('click.systemUsersList', 'a.invitations', function onInvitationsClick(event) {
        event.preventDefault();

        const ids: string[] = [];

        $('.grid-col-check input[type="checkbox"]').each(function eachCheckbox() {
            if (this.checked) {
                ids.push(String($(this).attr('id')));
            }
        });

        $.nette.ajax({
            type: 'post',
            url: sendInvitationsUrl,
            data: { ids },
        });
    });
}
